import {Button, ButtonGroup, ButtonProps, Grid} from "@mui/material";
import React from "react";
import {useGeneral} from "@contexts/GeneralContext.tsx";

export interface ConfirmationComponentOptions extends Pick<ButtonProps, 'color' | 'variant' | 'onClick' | 'endIcon' | 'disabled'> {
    label: string;
    hidden?: boolean;
}

export interface ConfirmationComponentProps {
    children: React.ReactNode;
    options?: ConfirmationComponentOptions[]
}

export function ConfirmationComponent(props: ConfirmationComponentProps): React.ReactElement {
    const {children, options} = props;
    const {pick} = useGeneral();
    // const btProps = pick<ButtonProps, 'color' | 'variant' | 'onClick' | 'endIcon'>(props);


    return (<Grid>
        <Grid container spacing={2}>
            <Grid size={12}>
                {children}
            </Grid>
            <Grid size={12}>
                <Grid container justifyContent={'end'} size={12} component={ButtonGroup}>
                    {
                        options?.map((option, i) => (
                            !option.hidden &&
                            <Button
                                key={option.label + i}
                                {...pick(option, 'endIcon', 'color', 'onClick', 'variant', 'disabled')}
                                color={option.color ?? 'primary'}
                                onClick={option.onClick}
                            >
                                {option.label}
                            </Button>
                            )
                        )
                    }
                </Grid>
            </Grid>
        </Grid>
    </Grid>)
}